<template>
  <div v-click-outside="handleClose" :class="$style.container">
    <div :class="$style.control" @click="handleToggle">
      <div v-m-r="10">{{ $t(getActiveOption.label) }}</div>
      <base-icon v-if="isVisible" name="arrows_chevron-top" :size="16" />
      <base-icon v-else name="arrows_chevron-bottom" :size="16" />
    </div>

    <transition name="fade" appear>
      <div
        v-if="isVisible"
        :class="$style.content"
      >
        <router-link
          v-for="(option, idx) in options"
          :key="idx"
          v-slot="{ navigate, isExactActive }"
          :to="{ name: option.name }"
          custom
        >
          <div
            :class="[
              $style.link,
              { [$style.active]: isExactActive },
            ]"
            @click="navigate"
          >
            {{ $t(option.label) }}
          </div>
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'DropdownNavigation',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    getActiveOption() {
      return this.options.find(option => option.name === this.$route.name) || null;
    },
  },
  methods: {
    handleClose() {
      this.isVisible = false;
    },
    handleToggle() {
      if (this.isVisible) {
        this.handleClose();
        return;
      }

      this.isVisible = true;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .content
    +flexbox
    +flex-direction(column)

  .control
    +flexbox
    +justify-content(center)
    +line-height(18)
    margin-bottom: 10px

  .link
    +tab-link
    cursor: pointer

    &:not(:last-child)
      margin-bottom: 5px

    &.active
      +tab-link-active
</style>
